import request from '@/utils/request'


// 训练场列表接口
export function getList (data = {}) {
    return request.postJson('/api/schWeb/region/list', data)
}